import React, { useRef, useLayoutEffect } from 'react'

const confettiColors = [
  'rgb(65, 205, 140)',
  'rgb(60, 170, 230)',
  'rgb(130, 120, 200)',
  'rgb(216, 74, 138)',
]
const confettiAnimations = [
  `c-confetti__flake--animation-slow`,
  `c-confetti__flake--animation-medium`,
  `c-confetti__flake--animation-fast`,
]

const Confetti = () => {
  const el = useRef<HTMLDivElement>(null!)
  const container = useRef<HTMLDivElement>(null!)
  const confettiInterval = useRef<number | null>(null)
  const removeTimeout = useRef<number | null>(null)

  useLayoutEffect(() => {
    const elOffsetWidth = el.current.offsetWidth

    confettiInterval.current = window.setInterval(() => {
      const confettiEl = document.createElement('div')
      const confettiSize = `${Math.floor(Math.random() * 3) + 7}px`
      const confettiBackground =
        confettiColors[Math.floor(Math.random() * confettiColors.length)]
      const confettiLeft = `${Math.floor(Math.random() * elOffsetWidth)}px`
      const confettiAnimation =
        confettiAnimations[
          Math.floor(Math.random() * confettiAnimations.length)
        ]

      confettiEl.classList.add('c-confetti__flake', confettiAnimation)
      confettiEl.style.left = confettiLeft
      confettiEl.style.width = confettiSize
      confettiEl.style.height = confettiSize
      confettiEl.style.backgroundColor = confettiBackground

      setTimeout(() => {
        container.current && container.current.removeChild(confettiEl)
      }, 3000)

      container.current.appendChild(confettiEl)
    }, 25)

    removeTimeout.current = window.setTimeout(() => {
      confettiInterval.current && window.clearInterval(confettiInterval.current)
      confettiInterval.current = null
      removeTimeout.current = null
    }, 4500)

    return () => {
      confettiInterval.current && window.clearInterval(confettiInterval.current)
      removeTimeout.current && window.clearTimeout(removeTimeout.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="c-confetti" ref={el}>
      <div ref={container} className="c-confetti__container" />
    </div>
  )
}

export default Confetti
